
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-10 sm:mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <img 
              src="https://static.readdy.ai/image/abcfde42a70d25526c2b82811ba21d87/0ba5fb94409f55e3f47bcb587233afbd.png"
              alt="Afriq Global Logo"
              className="h-10 sm:h-12 w-auto max-h-12 object-contain mb-4"
            />
            <p className="text-sm sm:text-base text-gray-900 leading-relaxed">
              Empowering businesses and individuals with modern digital solutions and world-class travel services.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm sm:text-base text-gray-900 hover:text-black transition-colors cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/goals" className="text-sm sm:text-base text-gray-900 hover:text-black transition-colors cursor-pointer">
                  Our Goals
                </Link>
              </li>
              <li>
                <Link to="/why-choose-us" className="text-sm sm:text-base text-gray-900 hover:text-black transition-colors cursor-pointer">
                  Why Choose Us
                </Link>
              </li>
              <li>
                <Link to="/affiliate-program" className="text-sm sm:text-base text-gray-900 hover:text-black transition-colors cursor-pointer">
                  Affiliate Program
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/almadaa-digital" className="text-sm sm:text-base text-gray-900 hover:text-black transition-colors cursor-pointer">
                  Almadaa Digital
                </Link>
              </li>
              <li>
                <Link to="/dennywise-travel" className="text-sm sm:text-base text-gray-900 hover:text-black transition-colors cursor-pointer">
                  Afriq Travel
                </Link>
              </li>
              <li>
                <Link to="/ark-care-foundation" className="text-sm sm:text-base text-gray-900 hover:text-black transition-colors cursor-pointer">
                  ARK CARE Foundation
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-phone-fill text-lg sm:text-xl mr-2 mt-1 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <a href="tel:+971545475624" className="text-sm sm:text-base text-gray-900 hover:text-black transition-colors cursor-pointer break-all">
                  +971 545475624
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-fill text-lg sm:text-xl mr-2 mt-1 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span className="text-sm sm:text-base text-gray-900">Dubai, UAE</span>
              </li>
              <li className="flex items-start">
                <i className="ri-whatsapp-fill text-lg sm:text-xl mr-2 mt-1 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <a 
                  href="https://wa.me/971545475624" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm sm:text-base text-gray-900 hover:text-black transition-colors cursor-pointer"
                >
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t-2 border-black/20 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm sm:text-base text-gray-900 text-center sm:text-left">
              &copy; {new Date().getFullYear()} Afriq Global. All rights reserved.
            </p>
            <div className="flex space-x-4 sm:space-x-6">
              <a href="#" className="text-gray-900 hover:text-black transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl sm:text-2xl w-6 h-6 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-gray-900 hover:text-black transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl sm:text-2xl w-6 h-6 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-gray-900 hover:text-black transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl sm:text-2xl w-6 h-6 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-gray-900 hover:text-black transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl sm:text-2xl w-6 h-6 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
